import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { KimMessageBody } from '../../../../backend/src/matter/subset/kim/dto/kim-message-body.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useSendKimMessage = (matterId?: string, subsetId?: string, threadId?: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async (payload: KimMessageBody) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
        data: { message: payload.message, files: payload.files, mentions: payload.mentions },
      });

      const response = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/threads/${threadId}/message`,
        fetchConfig,
      );
      if (!response.ok) {
        throw new Error('Sending Kim message failed');
      }
      return response.json();
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QueryEntity.KimMessages, { threadId }]);
      },
      onError: () => {
        toast.error('Failed to send message. Please try again.');
      },
    },
  );
};
